"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildAffiliateUrlFromHostData = buildAffiliateUrlFromHostData;
const SKIMLINKS_BASE = 'https://go.skimresources.com/?id=169538X1637407&url=';
// Mutating searchParams makes node re-serialize the whole URL, percent-encoding the braces of any
// placeholder still in the template - in the query as well as the path. Scoped to the two known
// tokens so a genuinely encoded brace elsewhere in the destination is left as it is.
const ENCODED_PLACEHOLDER = /%7B%7B(deviceId|activationId)%7D%7D/gi;
const restorePlaceholders = (value) => value.replace(ENCODED_PLACEHOLDER, (_match, name) => `{{${name}}}`);
function buildAffiliateUrlFromHostData(url, hostData, deviceId, activationId) {
    var _a, _b;
    if (!(hostData === null || hostData === void 0 ? void 0 : hostData.affiliateLinkWithUrl)) {
        return `${SKIMLINKS_BASE}${encodeURIComponent(url.href)}`;
    }
    const destination = decodeURIComponent(hostData.affiliateLinkWithUrl)
        .replace('{{encodedUrl}}', encodeURIComponent(url.href))
        .replace('{{url}}', url.href)
        .replace('{{deviceId}}', deviceId)
        .replace('{{activationId}}', activationId)
        .replace('{{path}}', encodeURIComponent(url.pathname));
    const deleteParamList = (_a = hostData.deleteParamList) !== null && _a !== void 0 ? _a : [];
    const appendParamList = (_b = hostData.appendParamList) !== null && _b !== void 0 ? _b : {};
    if (deleteParamList.length === 0 && Object.keys(appendParamList).length === 0) {
        return destination;
    }
    const withParams = new URL(destination);
    deleteParamList.forEach((key) => withParams.searchParams.delete(key));
    Object.entries(appendParamList).forEach(([key, value]) => withParams.searchParams.append(key, value));
    return restorePlaceholders(withParams.href);
}
